import type { LibraryImageType } from '~/modules/page-builder/types';
import { getPixelValue } from '~/utils/math';
import type { Position } from '@fluentui/react-northstar/dist/es/utils/positioner/types';

export const getTagTooltipDirection = (
    posX: number,
    posY: number,
    {
        WidthBeforeCrop,
        HeightBeforeCrop,
        CropPosX,
        CropPosY,
        WidthAfterCrop,
        HeightAfterCrop,
    }: LibraryImageType,
    tooltipWidth: number,
    tooltipHeight: number,
): Position => {
    let markerX = getPixelValue(posX, WidthBeforeCrop);
    let markerY = getPixelValue(posY, HeightBeforeCrop);

    markerX -= CropPosX;
    markerY -= CropPosY;

    const horizontalMidPoint = tooltipWidth / 2;
    const above = HeightAfterCrop - markerY < tooltipHeight;
    const after = markerX < horizontalMidPoint;
    const before = WidthAfterCrop - markerX < horizontalMidPoint;

    return after ? 'after' : before ? 'before' : above ? 'above' : 'below';
};
